import { configure, extend, localize, ValidationObserver, ValidationProvider } from 'vee-validate';
import ptBR from 'vee-validate/dist/locale/pt_BR.json';
import { email, max, min, min_value as minValue, required } from 'vee-validate/dist/rules';
import Vue from 'vue';

import CPFValidator from './cpf-validator';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

configure({
  classes: {
    invalid: 'is-invalid',
  },
});

extend('required', required);
extend('email', email);
extend('min', min);
extend('max', max);
extend('min_value', minValue);

extend('cpf', {
  validate: (value: any) => CPFValidator.isValid(value),
  message: 'Informe um CPF válido.',
});
localize('pt_BR', ptBR);
